import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import { AbWithTooltip } from "abreact/popup/AbWithTooltip";
import { KeyValue } from "abweb/utils/KeyboardUtils";
import { TypeUtils } from "abweb/utils/TypeUtils";
import { isValidElement } from "react";
import * as React from "react";
export class AbRadioButton extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "id", TypeUtils.generateUniqueId("radio-button"));
    _defineProperty(this, "onKeyDown", e => {
      if ([KeyValue.ARROW_UP, KeyValue.ARROW_RIGHT, KeyValue.ARROW_DOWN, KeyValue.ARROW_LEFT].includes(e.key)) {
        e.preventDefault();
        const radioButtons = Array.from(e.currentTarget.ownerDocument.querySelectorAll(`.ab-radio-button:not(.ab-disabled) input[name="${this.props.groupName}"], #${this.id}`));
        const thisIndex = radioButtons.findIndex(element => element.id === this.id);
        if (thisIndex >= 0) {
          let nextButton;
          if ([KeyValue.ARROW_UP, KeyValue.ARROW_LEFT].includes(e.key)) {
            nextButton = radioButtons[(thisIndex + radioButtons.length - 1) % radioButtons.length];
          } else {
            nextButton = radioButtons[(thisIndex + 1) % radioButtons.length];
          }
          nextButton.focus();
          nextButton.click();
        }
      }
    });
  }
  render() {
    // Do not put disabled on input component: causes mouse events to be dropped.
    const {
      id,
      className,
      style,
      disabled,
      ...radioButtonProps
    } = ReactUtils.inputProps("ab-radio-button", this.props, [/*#__PURE__*/isValidElement(this.props.label) ? 'react-element-label' : undefined]);
    // Manually remove data-test-id because deconstruction syntax can't.
    delete radioButtonProps["data-test-id"];
    const inputClassName = ReactUtils.classNamesString(["ab-radio-button-circle",
    // kept for legacy reasons
    "ab-radio-button-input", "abui", this.props.value && "ab-checked"]);
    return /*#__PURE__*/React.createElement(AbWithTooltip, {
      tooltip: this.props.tooltip
    }, /*#__PURE__*/React.createElement("label", {
      className: className,
      id: id,
      style: style,
      "data-test-id": this.props.dataTestId
    }, /*#__PURE__*/React.createElement("input", _extends({}, radioButtonProps, {
      id: this.id,
      className: inputClassName,
      type: "radio",
      name: this.props.name ?? this.props.groupName,
      checked: this.props.value,
      onChange: disabled ? undefined : this.props.onChange
      // Marked as readOnly when disabled or onChange is undefined because value cannot change. Handles browser complaint.
      ,
      readOnly: disabled || this.props.onChange === undefined,
      onKeyDown: this.onKeyDown
    })), /*#__PURE__*/React.createElement("span", {
      className: "ab-radio-button-visual"
    }), this.props.label));
  }
}
//# sourceMappingURL=AbRadioButton.js.map
